import axios from '@/libs/api.request'
// 获取案例分享列表
export const getExampleList = (params) => {
    return axios.request({
        url: 'example',
        method: 'get',
        params: params
    })
}

// 获取案例分享详情
export const getExampleDetail = (params) => {
    return axios.request({
        url: `example/${params.id}`,
        method: 'get'
    })
}
